//if(jQuery){
jQuery.fn.center = function (iteration) {
    let t=this;
    var width = $(t).outerWidth();
    var height = $(t).height();
    if(iteration>20)
        return;
    
    if(width){

        var left = Math.max(0, (($(window).width() - width) / 2)) + "px";
        var top = Math.max(0, (($(window).height() - height) / 2)) + "px";
        t.css("position","absolute");
        t.css("left", left);
       // t.css("top",top);
    } else{
        setTimeout( function(){
            $(t).center(iteration+1)
        } , 100);
    }

    return this;
}

$( window ).resize(function() {
    $( ".centered" ).each(function( index ) {
          $( this ).center(0);
      });
  });
//}
//else{
//    console.log("no jquery yet;");
//}


// WEBPACK FOOTER //
// components/jquery/Center.js